import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'delivery-engagements-tab-1-part',
	standalone: true,
	templateUrl: './delivery-engagements-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./delivery-engagements-tab-1.part.scss`],
})
export class DeliveryEngagementsTab1Part {
}
